import { Stack, TextField } from '@mui/material';

import { MARKET_TYPE_EXCLUSION_TYPE_OPTIONS, MARKET_TYPE_USED_FOR_OPTIONS } from '../../../../../../constants';
import FormSelect from '../../../../../molecules/FormSelect';
import { useMarketPicker } from './MarketPickerContext';

const styles = {
  filters: { borderTop: 1, borderColor: 'divider' },
  filterRow: {
    alignItems: 'flex-start',
    display: 'grid',
    gap: 1,
    gridTemplateColumns: { xs: '1fr', md: 'repeat(3, minmax(0, 1fr))' },
  },
} as const;

const MarketFilters = () => {
  const { state, actions, meta } = useMarketPicker();

  return (
    <Stack spacing={1} sx={{ ...styles.filters, p: 2 }}>
      <TextField
        label='Search'
        value={state.search}
        onChange={(event) => actions.setSearch(event.target.value)}
        size='small'
        fullWidth
      />
      <Stack sx={styles.filterRow}>
        <FormSelect label='Sport' name='sportId' control={meta.control} options={meta.sportOptions} size='small' />
        <FormSelect
          label='Used for'
          name='usedFor'
          control={meta.control}
          options={MARKET_TYPE_USED_FOR_OPTIONS}
          size='small'
        />
        <FormSelect
          label='Type'
          name='type'
          control={meta.control}
          options={MARKET_TYPE_EXCLUSION_TYPE_OPTIONS}
          size='small'
        />
      </Stack>
    </Stack>
  );
};

export default MarketFilters;
